import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { PermissionsService } from '@services/permissions/permissions.service';

@Injectable()
export class MaterialUiGuard {
    constructor(
        private router: Router,
        private permissionsService: PermissionsService,
    ) {}

    public canActivate(): boolean | UrlTree {
        return (
            this.permissionsService.checkPermission({
                name: 'material_ui',
            }) || this.router.parseUrl('/error/403')
        );
    }
}
